import { Link } from "react-router-dom";
import {
    AlignItems,
    Col,
    Column,
    Container,
    Gap,
    Gutter,
    Icon,
    JustifyContent,
    Row,
    Stack,
    StackDirection,
    StackWrap,
    Text,
    Wrapper
} from "@rebootui";

const ICONS_DOC_PATH = "/docs/content/icons";

const IconSupport = () => {

    const icons = [
        { icon: "heart", name: "Heart" },
        { icon: "star", name: "Star" },
        { icon: "graph-up-arrow", name: "Trending" },
        { icon: "rocket", name: "Rocket" },
        { icon: "check-lg", name: "Check" },
        { icon: "lightning-charge-fill", name: "Zap" },
        { icon: "feather", name: "Feather" },
        { icon: "arrows-fullscreen", name: "Scale" },
    ]

    const iconFeatures = [
        { icon: "image", name: "SVG-based" },
        { icon: "arrows-angle-expand", name: "Scalable" },
        { icon: "feather", name: "Lightweight" },
        { icon: "palette", name: "Easy customization" },
    ]
    return (
        <section className="py-md-7 py-6 bg-gray">
            <Container className="position-relative zi-99">
                <Wrapper className="text-center mb-6">
                    <Text className="h2 mb-3">
                        Built-in Icon Support
                    </Text>
                    <Text className="fs-5 mb-0 text-secondary">
                        Integrate Bootstrap Icons or any SVG icon system easily.
                    </Text>
                </Wrapper>
                <Row gutter={Gutter.G4}>
                    {iconFeatures.map((iconFeature) => (
                        <Column key={iconFeature.icon} col={[Col.Col12, Col.ColMd6, Col.ColLg3]}>
                            <Stack direction={StackDirection.Column} alignItems={AlignItems.Center} gap={Gap.Gap3} className="border border-black border-opacity-10 rounded-4 p-4 bg-white">
                                <Stack.Item className="icon bg-dark bg-opacity-5 text-dark p-3 rounded-4">
                                    <Icon name={iconFeature.icon} width={32} height={32} />
                                </Stack.Item>
                                <Text el="small">
                                    {iconFeature.name}
                                </Text>
                            </Stack>
                        </Column>
                    ))}
                </Row>
                <Row className="mt-5">
                    <Column col={Col.Col12}>
                        <Stack direction={StackDirection.Column} alignItems={AlignItems.Center} justifyContent={JustifyContent.Center} className="border border-black border-opacity-10 bg-white rounded-5 p-md-5 p-4">
                            <Text el="small" className="text-muted text-center">
                                Over 2,000+ icons ready to use in your projects
                            </Text>
                            <Stack direction={StackDirection.Row} justifyContent={JustifyContent.Center} alignItems={AlignItems.Center} gap={Gap.Gap3} wrap={StackWrap.Wrap} className="mt-xl">
                                {icons.map((icon) => (
                                    <Stack.Item key={icon.icon}>
                                        <Link
                                            to={ICONS_DOC_PATH}
                                            className="text-decoration-none text-reset"
                                            aria-label={`${icon.name} — open Icons documentation`}
                                        >
                                            <Stack direction={StackDirection.Column} alignItems={AlignItems.Center} gap={Gap.Gap3} className="px-4 hover-scale-icon">
                                                <Stack.Item className="icon bg-gray text-muted text-dark-hover p-3 rounded-4 border border-2 border-opacity-10 border-opacity-50-hover border-dark-hover tr-base">
                                                    <Icon name={icon.icon} width={26} height={25} />
                                                </Stack.Item>
                                                <Stack.Item>
                                                    <Text el="p" className="mb-0 text-muted fs-xs">{icon.name}</Text>
                                                </Stack.Item>
                                            </Stack>
                                        </Link>
                                    </Stack.Item>
                                ))}
                            </Stack>
                            <Stack.Item className="mt-5">
                                <Link
                                    to={ICONS_DOC_PATH}
                                    className="btn btn-sm btn-light shadow-l lh-160 border border-black border-opacity-10 rounded-4"
                                >
                                    Explore Icons
                                </Link>
                            </Stack.Item>
                        </Stack>
                    </Column>
                </Row>
            </Container>
        </section>
    )
}

export default IconSupport;

